import { computed } from 'vue';
import { appStoresKey } from '@pkg/modular-blocks/frontend/appStores';
import { useSiteManifestStore } from '~/app/stores/siteManifest';

/**
 * Provide CMS app-store URLs/badges to shared AppStore components
 * (moved out of apps/web so business can resolve them too).
 */
export default defineNuxtPlugin((nuxtApp) => {
  const siteManifestStore = useSiteManifestStore();
  nuxtApp.vueApp.provide(
    appStoresKey,
    computed(() => siteManifestStore.appStores),
  );
});
